module.exports = __webpack_public_path__ + "media/images/shipping_methods/bpost-f5ac8692bd8cd52cbf14ca7752367287.svg";